import axios from 'axios'
import qs from 'qs'
import router from '@/router/index.js'
import {
	Notification,
	Message
} from 'element-ui'



// 创建 axios 实例
var requests = axios.create({
	//   baseURL: process.env.VUE_APP_API, // 基础url,如果是多环境配置这样写，也可以像下面一行的写死。
	// baseURL: 'http://192.168.31.104:20005/',	
	// baseURL: 'http://192.168.101.6:20005/',
	baseURL: 'https://api.h6ds.com',
	timeout: 6000, // 请求超时时间
	responseType: 'json',
	// withCredentials: true,
})

requests.interceptors.request.use(
	req => {


		var token = localStorage.getItem('usertoken')
		req.data.token = token






		let need_change_url = [
			'api/user/login',
			'api/Wxapp/Token',
			'api/Wxapp/sc',
			'api/Wxapp/sc',
			'api/Wxapp/getCollect',
			'api/Wxapp/pullCollect',
			'api/Wxapp/editpass',
			'api/Wxapp/send',
			'api/user/register',
			'api/Wxapp/register',
			'api/hall/heihao',
			'api/hall/kehu',
			'api/Wxapp/getCArchives',
			'api/Wxapp/tihaolist',
			'api/Order/addorder',
			'api/Order/mylist',
			'api/order/detail',
			'api/order/cancel',
			'api/order/payOrder',
			'api/index/payOrder',

		];
		if (req.url == 'api/index/payOrder') {
			req.baseURL = "https://pay.h6ds.com"
		}




		if (need_change_url.includes(req.url)) {

			req.data = qs.stringify(req.data);
			req.headers = {
				"Content-Type": "application/x-www-form-urlencoded"
			}
		}

		return req
	},
	e => {



	}
)





// 错误处理函数
const err = (error) => {




	if (error.response) {
		const data = error.response.data
		// const token = Vue.ls.get(ACCESS_TOKEN)
		if (error.response.status === 403) {
			//         Notify({ type: 'danger', message: data.message||data.msg });
		}
		if (error.response.status === 401) {

			Message.error({
				message: '请先登录',
				duration: 3000,
				// offset: "580"
			})

			setTimeout(() => {
				router.push("/login")
			}, 1500)


			//         Notify({ type: 'danger', message: '你没有权限。' });
			// if (token) {
			//   store.dispatch('Logout').then(() => {
			//     setTimeout(() => {
			//       window.location.reload()
			//     }, 1500)
			//   })
			// }
		}
	}
	return Promise.reject(error)
}



// request interceptor(请求拦截器)
// requests.interceptors.request.use(config => {
// //   const token = Vue.ls.get(ACCESS_TOKEN)
//   const token = localStorage.getItem('token')
//   if (token) {
//     config.headers['token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
//   }
//   return config
// }, err)



// response interceptor（接收拦截器）
requests.interceptors.response.use((response) => {
	const res = response.data

	if (res.code !== 1 && res.code !== 200) {

		// 401:未登录;
		if (res.code === 401 || res.code === 403 || res.code === 999) {

		}



		return Promise.reject(res)
	} else {
		return res
	}
}, err)



export default {
	requests
}